(function () {
	const initProductAccordion = () => {
		$(".product-about__more-link").click(function () {
			const $title = $(this).closest(".product-about__accordion-title");
			const $description = $title.siblings(".product-about__accordion-description");

			if (!$title.hasClass("active")) {
				$(".product-about__accordion-title.active").removeClass("active");
				$(".product-about__more-link").attr("aria-expanded", "false");
				$(".product-about__accordion-description").stop().slideUp(300);

				$title.addClass("active");
				$(this).attr("aria-expanded", "true");
				$description.stop().slideDown(300);
			} else {
				$title.removeClass("active");
				$(this).attr("aria-expanded", "false");
				$description.stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
